import { WithAuthorization } from "../../../context";
import { Card } from "../../../components/Card";
import { Page } from "../../../components/Page";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { ScopeOneFactorsTab, ScopeThreeFactorsTab, ScopeTwoFactorsTab } from "./components";

function ConversionFactors() {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors"
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [selectedYear, setSelectedYear] = useState((new Date().getFullYear() - 1).toString());

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
          <Center>
            <TabList borderBottom="none">
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.scope")} 1</Tab>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.scope")} 2</Tab>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.scope")} 3</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <ScopeOneFactorsTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            </TabPanel>
            <TabPanel padding="0">
              <ScopeTwoFactorsTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            </TabPanel>
            <TabPanel padding="0">
              <ScopeThreeFactorsTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(ConversionFactors);